import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class VideoControlService {
  private currentVideo: Pick<HTMLVideoElement, 'pause'> | null = null;

  register(video: Pick<HTMLVideoElement, 'pause'>) {
    // Pause the currently playing video if different
    if (this.currentVideo && this.currentVideo !== video) {
      this.currentVideo.pause();
    }
    this.currentVideo = video;
  }

  unregister(video: Pick<HTMLVideoElement, 'pause'>) {
    if (this.currentVideo === video) {
      this.currentVideo = null;
    }
  }
}
